import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.accountTitle.query,
    method: 'post',
    data: requestBody
  })
}

// 获取详情
export function detail(requestBody) {
  return request({
    url: URL.finance.accountTitle.detail,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存
export function save(requestBody) {
  return request({
    url: URL.finance.accountTitle.save,
    method: 'post',
    data: requestBody
  })
}

// 删除
export function remove(requestBody) {
  return request({
    url: URL.finance.accountTitle.remove,
    method: 'post',
    data: requestBody
  })
}

// 初始化一级科目
export function initialize(data) {
  return request({
    url: URL.finance.accountTitle.initialize,
    method: 'post',
    data
  })
}

// 检查凭证是否用过辅助核算项目
export function checkAccountEntryAuxiliaryCreate(data) {
  return request({
    url: URL.finance.accountTitle.checkAccountEntryAuxiliaryCreate,
    method: 'post',
    data
  })
}

// 按余额货币获取账户名称
export function getAccountTitleByBalanceCurrency(data) {
  return request({
    url: URL.finance.accountTitle.getAccountTitleByBalanceCurrency,
    method: 'post',
    data
  })
}

// 保存科目辅助余额
export function saveAccountTitleAuxiliaryBalance(data) {
  return request({
    url: URL.finance.accountTitle.saveAccountTitleAuxiliaryBalance,
    method: 'post',
    data
  })
}
// 保存科目辅助余额 多币种
export function saveAccountTitleAuxiliaryBalanceByMultiCurrency(data) {
  return request({
    url: URL.finance.accountTitle.saveAccountTitleAuxiliaryBalanceByMultiCurrency,
    method: 'post',
    data
  })
}

// 删除科目辅助余额
export function removeAccountTitleAuxiliaryBalance(data) {
  return request({
    url: URL.finance.accountTitle.removeAccountTitleAuxiliaryBalance,
    method: 'post',
    data
  })
}

// 删除科目辅助余额 多币种
export function removeAccountTitleAuxiliaryBalanceByMultiCurrency(data) {
  return request({
    url: URL.finance.accountTitle.removeAccountTitleAuxiliaryBalanceByMultiCurrency,
    method: 'post',
    data
  })
}

// 利用编码查询上级编码
export function getAccountTitleName(data) {
  return request({
    url: URL.finance.accountTitle.getAccountTitleName,
    method: 'post',
    data
  })
}
